<template>

  <v-container fluid fill-height class="iframe-wrapper" pa-0>

    <iframe
      seamless="seamless"
      :src="getIframeSrc"
      allowfullscreen--
      class="iframe-class"
      >
    </iframe>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'

// Типы
interface UserData {
  access_token?: string
  [key: string]: any
}

interface AuthState {
  user: UserData | null
}

interface RootState {
  auth: AuthState
}

export default Vue.extend({
  name: 'SERVICE_STATUS',

  components: {},

  props: {},

  data(): {} {
    return {}
  },

  computed: {
    getUser(): UserData | null {
      const state = this.$store.state as unknown as RootState
      return state.auth.user
    },

    getIframeSrc(): string {
      const token = this.getUser?.access_token || ''
      const baseParams = this.$localhost
        ? '&kiosk=true&route=/app/widget/DockerContainersState&initApp=false'
        : '&kiosk=true&route=/app/widget/DockerContainersState'
      return `/e-ui?key=${token}${baseParams}`
    },
  },

  created(): void {
    // console.log(this.$options.name, 'getIframeSrc', this.getIframeSrc)
    // Метод предназначен для переопределения при необходимости
  },

  methods: {},
})
</script>

<style lang="css" scoped>

.iframe-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.iframe-class {
  border: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: block;
}

</style>
